export default (function (_ref) {
  var colors = _ref.colors;
  return {
    wrapper: {
      position: 'relative',
      zIndex: 1,
      width: '100%',
      top: function top(_ref2) {
        var height = _ref2.height,
          barHeight = _ref2.barHeight,
          stepHeight = _ref2.stepHeight;
        return "".concat((height - barHeight) / 2 - stepHeight, "px");
      }
    },
    min: {
      left: '0'
    },
    max: {
      right: '0'
    },
    range: {
      top: function top(_ref3) {
        var height = _ref3.height,
          barHeight = _ref3.barHeight,
          stepHeight = _ref3.stepHeight;
        return "".concat((height - barHeight) / 2 + stepHeight + 4, "px");
      },
      position: 'absolute',
      fontSize: '13px',
      color: colors.primaryLighter
    },
    stepLabel: {
      transform: 'translateX(-50%)'
    }
  };
});